import m from "../../../../geodata/es2015/region/usa/orLow";
window.am4geodata_region_usa_orLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/orLow.js
// module id = null
// module chunks = 